import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map, of } from 'rxjs';
import { environment } from '../../../environments';

export interface CountryStateCityCountry {
  id: number;
  name: string;
  iso2: string;
  iso3: string;
  phonecode: string;
  capital: string;
  currency: string;
  native: string;
  emoji: string;
}

export interface CountryStateCityState {
  id: number;
  name: string;
  iso2: string;
}

export interface CountryStateCityCity {
  id: number;
  name: string;
}

@Injectable({
  providedIn: 'root',
})
export class CountryStateCityService {
  private get baseUrl(): string {
    return `${environment.apiUrl}/countrystatecity`;
  }

  constructor(private http: HttpClient) {}

  getCountries(): Observable<CountryStateCityCountry[]> {
    return this.http
      .get<CountryStateCityCountry[] | { error: string }>(`${this.baseUrl}/countries`)
      .pipe(
        map((body) => (Array.isArray(body) ? body : [])),
        catchError(() => of([]))
      );
  }

  getStatesByCountry(countryIso2: string): Observable<CountryStateCityState[]> {
    if (!countryIso2?.trim()) {
      return of([]);
    }
    const code = encodeURIComponent(countryIso2.trim());
    return this.http
      .get<CountryStateCityState[] | { error: string }>(
        `${this.baseUrl}/countries/${code}/states`
      )
      .pipe(
        map((body) => (Array.isArray(body) ? body : [])),
        catchError(() => of([]))
      );
  }

  getCitiesByState(
    countryIso2: string,
    stateIso2: string
  ): Observable<CountryStateCityCity[]> {
    if (!countryIso2?.trim() || !stateIso2?.trim()) {
      return of([]);
    }
    const countryCode = encodeURIComponent(countryIso2.trim());
    const stateCode = encodeURIComponent(stateIso2.trim());
    return this.http
      .get<CountryStateCityCity[] | { error: string }>(
        `${this.baseUrl}/countries/${countryCode}/states/${stateCode}/cities`
      )
      .pipe(
        map((body) => (Array.isArray(body) ? body : [])),
        catchError(() => of([]))
      );
  }

  getCitiesByCountry(countryIso2: string): Observable<CountryStateCityCity[]> {
    if (!countryIso2?.trim()) {
      return of([]);
    }
    const code = encodeURIComponent(countryIso2.trim());
    return this.http
      .get<CountryStateCityCity[] | { error: string }>(
        `${this.baseUrl}/countries/${code}/cities`
      )
      .pipe(
        map((body) => (Array.isArray(body) ? body : [])),
        catchError(() => of([]))
      );
  }
}
